import React, { Component } from 'react';

class Plot extends Component {
    constructor(props) {
      super(props);

      this.height = 85;
 
      if (window.screen.width > 480) {
        this.width = 400;
      } else {
          this.width = window.screen.width - 100;
      }
      
      this.plot = null;
    }

    componentDidMount() {
        let { docs, aspect } = this.props;

        this.canvas = document.getElementById(`plot-canvas-${aspect}`);
        
        this.plot = new Stripplot(docs, aspect, this.width, this.height, 'words');
        const ctx = this.canvas.getContext('2d');
        this.plot.draw(ctx);
    }

    componentDidUpdate() {
        let { docs, aspect } = this.props;
        this.plot = new Stripplot(docs, aspect, this.width, this.height, 'words');
        const ctx = this.canvas.getContext('2d');
        this.plot.draw(ctx);
    }
  
    render() {
      let { title, aspect } = this.props;
  
      return (
        <div>
            <h3>{title}</h3>
            <canvas id={`plot-canvas-${aspect}`} 
                width={this.width} 
                height={this.height}></canvas>     
        </div>
      )
    }
  }

export default Plot;

// Classes to draw plots
const getMin = (rows, attr) => {
    return rows.reduce((acc, val) => {
        if (val[attr] < acc) {
            return val[attr];
        } else {
            return acc;
        }
    },100*100);
}

const getMax = (rows, attr) => {
    return rows.reduce((acc, val) => {
        if (val[attr] > acc) {
            return val[attr];
        } else {
            return acc;
        }
    },0);
}

class Stripplot {
    constructor(docs, aspect, width, height) {
        this.ypos = 10;
        this.aspect = aspect;
        this.height = height;
        this.width = width;
        this.medianOffset = 0;
        this.docs = docs;

        this.plotWidth = this.width;
        let docsOnly = docs.map(item => item.doc);
        this.max = getMax(docsOnly, aspect);
        this.min = getMin(docsOnly, aspect);
        let range = this.max - this.min;
        // Round max and min if they aren't too small
        if (range > 2) {
            this.max = Math.ceil(this.max);
            this.min = Math.floor(this.min);
        } 
        this.particles = [];

        this.plotWidth = width - 10;
        this.initParticles();
    }

    initParticles() {
        this.docs.forEach(doc => {
            if (doc.doc[this.aspect] !== 'na') {
                let particle = new Particle(doc.doc[this.aspect], this.ypos, this.min, this.max, this.plotWidth, doc.color);
                this.particles.push(particle);
            }  
        });
    }


    draw(ctx) {
        ctx.clearRect(0, 0, this.width, this.height);

        ctx.fillStyle = 'black';
        ctx.beginPath();
        ctx.moveTo(0, this.ypos);
        ctx.lineTo(this.width, this.ypos);
        ctx.stroke();

        for (let i = 0; i<this.particles.length; i++){
            this.particles[i].display(ctx);
        };  

        this.drawMinMaxLabels(ctx);
    }

    drawMinMaxLabels(ctx) {
        ctx.fillStyle = 'black';
        ctx.font = '12px sans-serif';
        let minLabel = Number(this.min.toFixed(1));
        let maxLabel = Number(this.max.toFixed(1));
        if (this.aspect === 'f_score') {
            minLabel = 'low';
            maxLabel = 'high';
        } else if (this.aspect === 'flesch_kincaid') {
            if (this.min < 9) {
                minLabel = `${minLabel}th grade`;
            } else if (this.min < 13) {
                minLabel = 'high school';
            } else if (this.min > 13) {
                minLabel = 'college level+';
            }
            if (this.max < 9) {
                maxLabel = `${minLabel} grade`;
            } else if (this.max < 13) {
                maxLabel = 'high school';
            } else if (this.max > 13) {
                maxLabel = 'college level+';
            }
        } else if (this.aspect === 'length') {
            minLabel = `${minLabel} words`;
        } else if (this.aspect === 'adjective_density') {
            minLabel = `${minLabel} adjectives per 100 words`;
        } else if (this.aspect === 'prop_numbers') {
            minLabel = `${minLabel} numbers per 100 words`;
        }
        ctx.textAlign = 'left';
        ctx.fillText(minLabel, 0, this.ypos + 30 + this.medianOffset);
        ctx.textAlign = 'right';
        ctx.fillText(maxLabel, this.width, this.ypos + 30 + this.medianOffset);
    }
  }

  class Particle {

    constructor(datapoint, ypos, min, max, plotWidth, color) {
        this.x = plotWidth * ((datapoint - min)/(max - min)) + 5;
        this.y = ypos;
        this.radius = 5;
        this.label = Number(datapoint.toFixed(1));
        this.color = color;
    }

    display(ctx) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, 2 * Math.PI);

        //ctx.globalAlpha = 0.5;
        ctx.strokeStyle = 'black';
        ctx.fillStyle = this.color;

        ctx.fill();
        ctx.stroke();
    }
  }

